// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveButton-pane-b9c3{padding:12px 0 8px;background-color:var(--ui-background-color)}.SaveButton-sticky-b9c3{z-index:1;position:sticky;bottom:0}.SaveButton-stand-b9c3{padding:0}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/SaveButton/SaveButton.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA,CACA,2CAAA,CAGF,wBACE,SAAA,CACA,eAAA,CACA,QAAA,CAGF,uBACE,SAAA","sourcesContent":[".pane {\n  padding: 12px 0 8px;\n  background-color: var(--ui-background-color);\n}\n\n.sticky {\n  z-index: 1;\n  position: sticky;\n  bottom: 0;\n}\n\n.stand {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `SaveButton-pane-b9c3`,
	"sticky": `SaveButton-sticky-b9c3`,
	"stand": `SaveButton-stand-b9c3`
};
module.exports = ___CSS_LOADER_EXPORT___;
